import React, { PropsWithChildren } from "react";
import cx from "classnames";

interface Props {
  isSelected?: boolean;
  onClick?: () => void;
}

const ThumbnailButton = ({
  isSelected,
  onClick,
  children,
}: PropsWithChildren<Props>) => {
  const buttonClass = cx(
    "h-20 w-20 rounded-[10px] border border-white/20 opacity-60 hover:opacity-100 flex-none",
    { "outline outline-2 !opacity-100 outline-white": isSelected }
  );

  return (
    <button onClick={onClick} className={buttonClass}>
      {children}
    </button>
  );
};

export default ThumbnailButton;
